module.exports = __webpack_public_path__ + "assets/img/7.48e38725.jpg";